import { Button, Checkbox, Col, Form, Input, notification, Row } from 'antd'
// import { Link } from "react-router-dom";
import {
    API_ERR_MESSAGE,
    BASE_URL,
    EMAIL_PATTERN,
    PHONE_PATTERN,
    SESSION_DAYS,
} from '../../config/constant'
import './style/loginForm.scss'

import axios from 'axios'
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { editUserApi } from '../../config/Api'
import { createAuthCookie, createCookie } from '../../config/CookieScript'
import { takeLogOutMessage } from '../../services/LogOut'

export const Login = () => {
    // dotenv.config();
    const navigate = useNavigate()
    const [form] = Form.useForm()

    const [IsUserLogin, setIsUserLogin] = useState(false)

    useEffect(() => {
        setIsUserLogin(false)

        // reason for a forced logout, e.g. the account was deactivated
        const logOutMessage = takeLogOutMessage()
        if (logOutMessage) {
            notification.warning({ message: logOutMessage })
        }
    }, [])

    // async function loginUser(data) {
    //     axios
    //         // .post('http://localhost:8000/v1/oauth/token',
    //         // .post('http://192.168.1.2:8000/v1/oauth/token',
    //         // .post('http://localhost:8000/v1/oauth/token',
    //         .post('http://localhost:3000/v1/oauth/token',
    //             data
    //         )
    //         .then((res) => {
    //             {
    //                 console.log("tokencode",res.data);
    //                 localStorage.setItem('id', res.data.user.id)
    //                 setIsUserLogin(true);
    //                 let userData = res.data.user
    //                 createCookie(
    //                     'user_name',
    //                     `${userData.name}`,
    //                     1,
    //                 )
    //                 createAuthCookie('auth_token', res.data.access_token, 1)
    //                 createCookie('role', res.data.user.role, 1)
    //                 localStorage.setItem('user', JSON.stringify(res.data))
    //                 // if (rememberMe) {
    //                 //     createCookie('gm360_token', response.token, 365)
    //                 //     createCookie('role', response.data.role, 365)
    //                 // } else {
    //                 //     createCookie('gm360_token', response.token, 1)
    //                 //     createCookie('role', response.data.role, 1)
    //                 // }
    //                 navigate("/Dashboard");
    //                 axios.defaults.headers.common.Authorization = `Bearer ${readCookie('authToken')}`
    //             }
    //         })
    //         .catch((err) => {
    //             if (err.response) {
    //                 // console.log(err.response);
    //                 // if (err.response.data.code === 401) {
    //                 setIsUserLogin(false);
    //                 notification.error({
    //                     message: 'Incorrect User Credentials incorrect',
    //                 });
    //                 // }
    //             }
    //         })
    // }

    //  for admin
    // ===================
    const staticuserdata = {
        user: {
            id: 4,
            name: 'shrey Patel',
            email: 'shrey19396@gmail.com',
            last_logged_in: null,
            created_at: '2022-11-05T11:53:59.000000Z',
            updated_at: '2022-12-17T05:47:14.000000Z',
            type_of_account: 'Allopathic Doctor',
            phone: '9099885205',
            status: false,
            herbs_management_right: true,
            measurements_management_right: true,
            add_recipes_right: true,
            role: 'Admin',
            plan_id: 10,
            plan: {
                id: 10,
                name: 'silver',
                price: '4000',
                plan_status: true,
                created_at: '2022-11-30T12:05:17.000000Z',
                updated_at: '2023-01-28T12:04:16.000000Z',
                active_clients: 3,
            },
        },
    }

    const mohituserdata = {
        id: 20,
        name: 'Mohit',
        email: 'Mohit@gmail.com',
        last_logged_in: null,
        created_at: '2023-12-13T12:11:28.000000Z',
        updated_at: '2023-12-13T12:11:28.000000Z',
        type_of_account: 'Nutritionist General',
        phone: '5050505050',
        status: false,
        herbs_management_right: false,
        measurements_management_right: false,
        add_recipes_right: false,
        role: 'Nutritionist',
        plan_id: 15,
        plan: {
            id: 15,
            name: 'Gold',
            price: '1250',
            plan_status: true,
            created_at: '2023-03-13T10:42:46.000000Z',
            updated_at: '2023-11-06T10:52:21.000000Z',
            active_clients: 25,
        },
    }

    //  for Nutritionist
    // ===================
    const staticNutritionistuserdata = {
        user: {
            id: 6,
            name: 'Krunal Patadiya',
            email: 'reactDev@gmail.com',
            last_logged_in: null,
            created_at: '2022-11-05T13:03:11.000000Z',
            updated_at: '2023-03-11T07:05:56.000000Z',
            type_of_account: 'Allopathic Doctor',
            phone: '9099885205',
            status: true,
            herbs_management_right: true,
            measurements_management_right: true,
            add_recipes_right: true,
            role: 'Nutritionist',
            plan_id: 10,
            plan: {
                id: 10,
                name: 'silver',
                price: '4000',

                plan_status: true,
                created_at: '2022-11-30T12:05:17.000000Z',
                updated_at: '2023-01-28T12:04:16.000000Z',
                active_clients: 3,
            },
        },
    }
    const staticNutritionistuserdataRakesh = {
        id: 17,
        name: 'Rakesh',
        email: 'Rakesh@gmail.com',
        last_logged_in: null,
        created_at: '2023-11-06T05:21:51.000000Z',
        updated_at: '2023-11-06T05:21:51.000000Z',
        type_of_account: 'Allopathic Doctor',
        phone: '5214698712',
        status: true,
        herbs_management_right: false,
        measurements_management_right: false,
        add_recipes_right: false,
        role: 'Nutritionist',
        plan_id: 12,
        plan: {
            id: 12,
            name: 'bronze',
            price: '3500',
            plan_status: true,
            created_at: '2022-11-30T12:29:52.000000Z',
            updated_at: '2022-12-16T13:14:23.000000Z',
            active_clients: 25,
        },
    }
    // const staticNutritionistuserdata = {
    //     "user": {
    //         "id": 15,
    //         "name": "Aakash",
    //         "email": "a@gmail.com",
    //         "last_logged_in": null,
    //         "created_at": "2022-12-20T08:14:21.000000Z",
    //         "updated_at": "2023-03-11T07:05:54.000000Z",
    //         "type_of_account": "Allopathic Doctor",
    //         "phone": "5050505050",
    //         "status": true,
    //         "herbs_management_right": true,
    //         "measurements_management_right": true,
    //         "add_recipes_right": false,
    //         "role": "Nutritionist",
    //         "plan_id": 10,
    //         "plan": {
    //             "id": 10,
    //             "name": "silver",
    //             "price": "4000",
    //             "plan_status": true,
    //             "created_at": "2022-11-30T12:05:17.000000Z",
    //             "updated_at": "2023-01-28T12:04:16.000000Z",
    //             "active_clients": 3
    //         }
    //     },
    // }

    const ayurvedicNutritionistuserdata = {
        id: 16,
        name: 'abc',
        email: 'abc@gmail.com',
        last_logged_in: null,
        created_at: '2023-03-13T07:26:36.000000Z',
        updated_at: '2023-03-13T07:39:51.000000Z',
        type_of_account: 'Nutritionist (Ayurveda)',
        phone: '7894561230',
        status: true,
        herbs_management_right: false,
        measurements_management_right: false,
        add_recipes_right: false,
        role: 'Nutritionist',
        plan_id: 14,
        plan: {
            id: 14,
            name: 'Pro',
            price: '1500',
            plan_status: true,
            created_at: '2023-03-11T12:02:32.000000Z',
            updated_at: '2023-11-06T10:56:37.000000Z',
            active_clients: 100,
        },
    }

    async function loginUser(data) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/v1/oauth/token`,
                data
            )

            if (response.status === 200) {
                // console.log("tokencode", response?.data?.access_token);
                let accessToken = response?.data?.access_token
                // axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
                axios.defaults.headers.common[
                    'Authorization'
                ] = `Bearer ${accessToken}`
                const userData = response.data.user
                // Use Promise to ensure Bearer token is set before calling getLoginUserDetails
                // await new Promise(resolve => setTimeout(resolve, 2000));

                // Now call getLoginUserDetails with the Bearer token
                // getLoginUserDetails(accessToken);

                setIsUserLogin(true)
                // createCookie('user_name', userData.name, 1);
                // createAuthCookie('auth_token', response.data.access_token, 1);
                // createCookie('role', userData.role, 1);
                // localStorage.setItem('user', JSON.stringify(response.data));

                //  static data for admin
                // ================================

                // createCookie('user_name', 'Shrey', 1);
                // createAuthCookie('auth_token', response.data.access_token, 1);
                // createCookie('role', 'Admin', 1);
                // localStorage.setItem('user', JSON.stringify(staticuserdata));
                // localStorage.setItem('id', 4);

                // rakesh nutritionist
                // createCookie('user_name', 'Rakesh', 1);
                // createAuthCookie('auth_token', response.data.access_token, 1);
                // createCookie('role', 'Nutritionist', 1);
                // localStorage.setItem('user', JSON.stringify(staticNutritionistuserdataRakesh));
                // localStorage.setItem('id', 17);

                // mohit

                // createCookie('user_name', 'Mohit', 1);
                // createAuthCookie('auth_token', response.data.access_token, 1);
                // createCookie('role', 'Nutritionist', 1);
                // localStorage.setItem('user', JSON.stringify(mohituserdata));
                // localStorage.setItem('id', 20);

                // common nutritionist
                // createCookie('user_name', 'Rakesh', 1);
                // createAuthCookie('auth_token', response.data.access_token, 1);
                // createCookie('role', 'Nutritionist', 1);

                // //  static data for nutritionist  Krunal
                // ================================

                // createCookie('user_name', 'Krunal Patadiya', 1);
                // createAuthCookie('auth_token', response.data.access_token, 1);
                // createCookie('role', 'Nutritionist', 1);
                // localStorage.setItem('user', JSON.stringify(staticNutritionistuserdata));
                // localStorage.setItem('id', 15);

                // //  static data for nutritionist RAKESH ALLOPATHIC
                // ================================

                // localStorage.setItem('user', JSON.stringify(staticNutritionistuserdataRakesh));
                // localStorage.setItem('id', staticNutritionistuserdataRakesh?.id);

                // //  ayurvedic nutritionist abc AYURVEDIC DOCTOR
                // ================================
                // createCookie('user_name', 'abc', 1);
                // createAuthCookie('auth_token', response.data.access_token, 1);
                // createCookie('role', 'Nutritionist', 1);
                // localStorage.setItem('user', JSON.stringify(ayurvedicNutritionistuserdata));
                // localStorage.setItem('id', ayurvedicNutritionistuserdata?.id);

                // Set the authorization token for future Axios requests.
                // axios.defaults.headers.common.Authorization = `Bearer ${response.data.access_token}`;
                // setTimeout(() => {
                //     getLoginUserDetails(accessToken)
                // }, 2000)
                // console.log("abc acessToken", accessToken);
                // const res = await axios.post('http://localhost:8000/api/login', {}, {
                //     headers: {
                //         Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiN2NiYjYyZDY3Yzk4NmY0OTM0MDM2ZTk1YmM0YmE5MTQ4MzVmMjljMzk0YTI1NWVlYjhlMDY1MDgwNmQ0Y2I2ZmQ3N2Q0Y2U0NWYyMWE5YTQiLCJpYXQiOjE3MDMwNzkzMTMsIm5iZiI6MTcwMzA3OTMxMywiZXhwIjoxNzM0NzAxNzEzLCJzdWIiOiI1Iiwic2NvcGVzIjpbXX0.lNnOP2wwdSO5GEjuVXQVjB_Brm8cR-KUulL2AmPYtwyyzuxuq_44UJ8iE11Ghn20lNkwS1xeluZnSQyKdRoEQaNl5h42qx8OnnvG8v6t34XJoORR_uv6L3jdADrZohEBGjSiDafZFpcfjvWhSHWrltWntOcNrREpkCDbh-SSnY3jxp3Su8TZjRFclmty-AhH5pRPKRQoc_1cBReEBNrmTJ_7WHYvLH96pUYvlLgQCeSsj_iL3VsSVrDPK0zB9kFXQCILl-Raxtf2v4Yx0T8POEf7gbUx9YqMagXTCZCcMv0UkuRzo34Wdh7wFyoO9xwYIN1wAtQ5SWIT3W6ZDeuWFFjxgaW6xEtvczYpRc9CDxD8w8anHRN3Zc0-mfwXVo5RhQtvaRj2wHSzevhXDG1VvruVWdNhOgMAJr2bDURBATs9-cmhI6YLx3Z0MkFU1vEjCrSaTAQvX-WETe7TJeoxwyDZUi5hOJ9XjNtIwDM51hIAznn6YthBta4kOC1KO9Ilno85oz1MJfHaWrV0WaRa8s6_bmm778io7FzUGX7_22520cUMnTdGd-tu6Klm-lqhIsqy_e2MTBxxxkL0Y7IfgQpORtKEFC9j_h1EGbFdP1Vf-DhvJ7P1gsStGjtbSSEP6Ysc1dBLtj6hTxrpR2tjQgOHbeBuApkqT0PDkzvmMww`,
                //     },
                // });
                // Axios POST request with bearer token
                // fetch('http://localhost:8000/api/login', {
                fetch(`${BASE_URL}/login`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({}),
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(
                                `HTTP error! Status: ${response.status}`
                            )
                        }
                        return response.json()
                    })
                    .then((data) => {
                        // Handle success

                        // createCookie('user_name', 'Rakesh', 1);
                        // createAuthCookie('auth_token', response.data.access_token, 1);
                        // createCookie('role', 'Nutritionist', 1);
                        // localStorage.setItem('user', JSON.stringify(staticNutritionistuserdataRakesh));
                        // localStorage.setItem('id', 17);

                        const userData = data.user
                        const userObjData = { user: data.user }
                        // const userData = { "user": data.user };
                        console.log('MyUserResponse:', userData)
                        createCookie('user_name', userData?.name, SESSION_DAYS)
                        // createCookie('auth_token', accessToken, 1);
                        createAuthCookie('auth_token', accessToken, SESSION_DAYS)
                        createCookie('role', userData?.role, SESSION_DAYS)
                        localStorage.setItem(
                            'user',
                            JSON.stringify(userObjData)
                        )
                        localStorage.setItem('id', userData?.id)
                        // localStorage.setItem('title', 'Dashboard')
                        setIsUserLogin(true)
                        if (userData?.role == 'Admin') {
                            navigate('/users-list')
                        } else {
                            // navigate("/Dashboard");
                            navigate('/Home')
                        }
                    })
                    .catch((error) => {
                        // Handle error
                        console.error('Error:', error)
                    })

                // await getLoginUserDetails(accessToken)
                // navigate("/Dashboard");
            }
        } catch (error) {
            if (error.response) {
                setIsUserLogin(false)
                const data = error.response.data
                notification.error({
                    // deactivated accounts get their own message, anything else is treated as wrong credentials
                    message:
                        data?.error === 'account_inactive'
                            ? data.message
                            : 'Incorrect User Credentials',
                })
            }
        }
    }

    // from login user access token and get the user detail (role,rights etc)
    // ==========================
    const getLoginUserDetails = async (accessToken) => {
        try {
            // Set Bearer token in headers
            axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`
            // if (axios.defaults.headers.common.Authorization) {
            // Make the API call to get user details
            // const res = await getLoginUserDetailsApi();
            // const res = await axios.post('http://localhost:8000/api/login', {}, {
            //     // headers: {
            //     //     Authorization: `Bearer ${accessToken}`,
            //     // },
            // });
            const res = await axios.post(
                'http://localhost:8000/api/login',
                {},
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            )
            if (res?.data) {
                notification.success({
                    message: 'User Details fetched successfully',
                })

                const userData = res.data.user
                console.log('aa res', userData)

                createCookie('user_name', userData?.name, SESSION_DAYS)
                createAuthCookie('auth_token', res?.data?.access_token, SESSION_DAYS)
                createCookie('role', userData?.role, SESSION_DAYS)
                localStorage.setItem('user', JSON.stringify(userData))
                localStorage.setItem('id', userData?.id)
                setIsUserLogin(true)

                navigate('/Dashboard')
            }
            // }
        } catch (err) {
            notification.error({
                message: API_ERR_MESSAGE,
            })

            // Handle errors or set setIsUserLogin(false) if needed
        }
    }

    // async function loginUser(data) {
    //     try {
    //         const response = await axios.post('http://localhost:8000/v1/oauth/token', data);

    //         if (response.status === 200) {
    //             console.log("tokencode", response?.data?.access_token);
    //             let accessToken = response?.data?.access_token;
    //             if (accessToken) {
    //                 // Set Bearer token in headers
    //                 axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    //                 // Now call getLoginUserDetails with the Bearer token
    //                 await getLoginUserDetails(accessToken);

    //                 setIsUserLogin(true);
    //             } else {
    //                 // Handle case where the access token is not present in the response
    //                 notification.error({
    //                     message: 'Token not exist',
    //                 });
    //             }
    //         }
    //     } catch (error) {
    //         if (error.response) {
    //             setIsUserLogin(false);
    //             notification.error({
    //                 message: 'Incorrect User Credentials',
    //             });
    //         }
    //     }
    // }

    // // Call the API to get user details using the provided Bearer token
    // const getLoginUserDetails = async (accessToken) => {
    //     try {
    //         // Set Bearer token in headers
    //         axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    //         // Make the API call to get user details
    //         const res = await axios.post('http://localhost:8000/api/login', {}, { accessToken },
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${accessToken}`,
    //                 },
    //             }
    //         );

    //         if (res.status === 200) {
    //             notification.success({
    //                 message: "User Details fetched successfully",
    //             });

    //             const userData = res.data.user;

    //             createCookie('user_name', userData?.name, 1);
    //             createAuthCookie('auth_token', res?.data?.access_token, 1);
    //             createCookie('role', userData?.role, 1);
    //             localStorage.setItem('user', JSON.stringify(userData));
    //             localStorage.setItem('id', userData?.id);
    //             setIsUserLogin(true);

    //             navigate("/Dashboard");
    //         }
    //     } catch (err) {
    //         notification.error({
    //             message: API_ERR_MESSAGE,
    //         });

    //         // Handle errors or set setIsUserLogin(false) if needed
    //     }
    // };

    // set the nutritionist data to form components for edit
    //==============================
    const editUserDetails = (userId) => {
        editUserApi(id)
            .then((res) => {
                if (res.status === 200) {
                    let userData = res.data.data
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }

    const onFinish = async (values) => {
        // console.log(values);
        // console.log(process.env.REACT_APP_CLIENT_SECRET);
        const data = {
            grant_type: 'password',
            // "client_id": 2,
            client_id: 12,
            // "client_secret": process.env.REACT_APP_CLIENT_SECRET,
            // "client_secret": "mFOdVPvrCEPDmnHxKdaqLHcGg4g9f2E6W7UQ2jBr",
            client_secret: '2LJjXICXAuqviyi3oH7ZsdEO2vUS7hMVbXPJJHxc',
            password: values.password,
            // spaces around the email are ignored (capital letters are handled by the backend)
            username: (values.email || '').trim(),
            scope: '',
        }
        loginUser(data)
        // userloginApi(data)
        //     .then((res) => {
        //         if (res.status === 200) {
        //             setIsUserLogin(true);
        //             console.log('res', res.data.user);
        //             let userData = res.data.user
        //             createCookie(
        //                 'user_name',
        //                 `${userData.name}`,
        //                 1,
        //             )
        //             createCookie('auth_token', res.data.access_token, 1)
        //             // if (rememberMe) {
        //             //     createCookie('gm360_token', response.token, 365)
        //             //     createCookie('role', response.data.role, 365)
        //             // } else {
        //             //     createCookie('gm360_token', response.token, 1)
        //             //     createCookie('role', response.data.role, 1)
        //             // }
        //             navigate("/Dashboard");
        //             axios.defaults.headers.common.Authorization = `Bearer ${readCookie(
        //                 'auth_token'
        //             )}`
        //         }
        //     })
        //     .catch((err) => {
        //         if (err.response) {
        //             console.log(err.response);
        //             // if (err.response.data.code === 401) {
        //             setIsUserLogin(false);
        //             notification.error({
        //                 message: 'Incorrect User Credentials incorrect',
        //             });
        //             // }
        //         }
        //     });
    }
    // const Login = () => {
    //     localStorage.setItem("user", JSON.stringify({ name: "Admin", email: "admin@gmail.com", role: "Admin" }))
    // }
    return (
        <div className="loginForm">
            <Form
                name="loginForm"
                className="loginForm"
                form={form}
                onFinish={onFinish}
            >
                <div className="logoSection">
                    {/* <img src={logo} width={200} alt="logo" className="logo" /> */}
                    <h2 className="mb-0">Nutri Nexus</h2>
                </div>
                <Row justify="center">
                    <Col
                        xs={24}
                        md={16}
                        xl={10}
                        xxl={{ span: 7 }}
                        className="rightForm"
                    >
                        <div id="loginFormContent" className="p-4 rounded">
                            <h4 className="text-uppercase text-center login-title">
                                Login
                            </h4>
                            <label className="form-input-label">Email :</label>
                            <Form.Item
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please insert Email or Phone Number!',
                                    },
                                    {
                                        pattern: EMAIL_PATTERN || PHONE_PATTERN,
                                        message: 'Please insert valid data!',
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Mobile Number or Email"
                                    className="mt-2 p-2"
                                />
                            </Form.Item>
                            <label className="form-input-label text-start">
                                Password :
                            </label>
                            <Form.Item
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please insert Password!',
                                    },
                                ]}
                            >
                                <Input.Password
                                    placeholder="Password"
                                    className="mt-2 p-2"
                                />
                            </Form.Item>
                            <Form.Item
                                name="remember"
                                valuePropName="checked"
                                className="mb-0 text-start"
                            >
                                <Checkbox checked id="rememberMe">
                                    Remember me
                                </Checkbox>
                            </Form.Item>
                            <Button
                                htmlType="submit"
                                block
                                className="submit-button border-0 rounded"
                            >
                                Login
                            </Button>
                            <Button
                                block
                                pt-3
                                className="mt-3 rounded"
                                id="forgot-password-button"
                            >
                                <Link to={{ pathname: '/forget-password' }}>
                                    Forget Your Password
                                </Link>
                            </Button>
                            <Button
                                block
                                className="mt-3 rounded"
                                id="register-button"
                            >
                                <Link to={{ pathname: '/register' }}>
                                    Register
                                </Link>
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

// export const LogOut = () => {
//     useEffect(() => {
//         logOut()
//     }, [])
//     const logOut = async () => {
//         logOutApi()
//             .then((res) => {
//                 navigate('/')
//             })
//             .finally(() => {
//                 eraseCookie('auth_token')
//                 // eraseCookie('user_name')
//                 // eraseCookie('role')
//                 localStorage.clear()
//                 navigate('/')
//             })
//     }
// }
